<template>
  <CheckboxEl v-model="model">
    <span class="text-sm text-neutral">
      Ich stimme den
      <a
        href="https://infra-analytics.de/agb/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-color1 underline"
        >Allgemeinen Geschäftsbedingungen</a
      >
      und den
      <a
        href="https://infra-analytics.de/datenschutz/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-color1 underline"
        >Datenschutzbestimmungen</a
      >
      zu und bestätige, dass ich diese gelesen und verstanden habe.
    </span>
  </CheckboxEl>
</template>

<script setup>
import CheckboxEl from '@/components/storybook/src/stories/CheckboxEl/CheckboxEl.vue';

const model = defineModel({ type: Boolean, required: true });
</script>
